export default {
    "dataIterator": {
        "rowsPerPageText": "Items per page:",
        "rowsPerPageAll": "All",
        "pageText": "{0}-{1} of {2}",
        "noResultsText": "No matching records found",
        "nextPage": "Next page",
        "prevPage": "Previous page"
    },
    "dataTable": {
        "rowsPerPageText": "Rows per page:"
    },
    "noDataText": "No data available",

    "app": {
        "name": "BZUCO Inspector",
        "reseted": "All tickets reset...",
        "networkError": "Server error, please check network connection and try again...",
        "networkNotAvailable": "No connection",
    },
    "menu": {
        "test": "Barcode reader test",
        "settings": "Settings",
        "admin": "Admin",
        "resetTickets": "Reset tickets",
        "resetState": "Reset application",
        "logout": "Logout"
    },
    "home": {
        "login": "Login",
        "lastEvent": "Last selected event",
        "chooseEvent": "Choose event"
    },
    "event": {
        "chooseEvent": "Choose event",
        "chooseEventPast": "Past events",
        "confirm": "Confirm event selection",
        "showPast": "show past items",
    },
    // "checkpoint": {
    //     "chooseCheckpoint": "Choose checkpoint",
    //     "set0": "no ticketsets",
    //     "set1": "1 ticketset",
    //     "set2": "{0} ticketsets",
    //     "set5": "{0} ticketsets",
    // },
    "zone": {
        "chooseZone": "Select zone(s)",
        "confirm": "Confirm zone selection"
    },
    "ticketsets": {
        "chooseTicketsets": "Select ticketsets",
        "selectAll": "Select all",
        "ticketCount": "Ticket count:"
    },
    "scanner": {
        "tickets": "Tickets:",
        "startReader": "Start reader",
        "startReaderDescription": "Browser need interaction with user for playing system sounds for notifications. Confirm please this dialog by pressing \"OK\" button.",
        "specialWarning": "Warning",
        "specialType": "Ticket of special type:",
        "refuse": "Refuse",
        "confirm": "Confirm",
        "messageSuccess": "Code {0} accepted",
        "messageSuccessPrice": "Code {0} accepted<br /><big>Price: <b>{1}</b></big>",
        "messageSuccessTicketsetPrice": "Code {0} accepted<br /><big>Set: <b>{1} / {2}</b></big>",
        "messageSuccessTicketset": "Code {0} accepted<br /><big>Set: <b>{1}</b></big>",
        "messageSuccessEvent": "Code {0} accepted<br /><big>Event: <b>{1}</b>, Ticketset: {2}</big>",
        "messageSuccessNosend": "Code {0} accepted (not sent)",
        "messageRead": "Code {0} read",
        "messageUsed": "Code {0} already used by {1}",
        "messageUnsend": "Code {0} already used (by me, not sent)",
        "messageNotFound": "Code {0} not found",
        "messageBadSlot": "Code {0} not valid for this zone/slot",
        "manualTitle": "Manual code entry",
        "loading": "loading tickets...",
        "nfcNotFound": "No valid ticket on card"
    },
    "login": {
        "title": "Login to mobile app",
        "username": "Username",
        "password": "Password",
        "login": "Login",
    },
    "settings": {
        "title": "Settings",
        "sound": "Sound",
        "soundSub": "Enable sound notifications",
        "camera": "Camera",
        "nfc_heading": "NFC",
        "nfc": "Read NFC tags",
        "language": "Language",
        "langCs": "Czech",
        "langEn": "English",
        "qTitle": "Advanced camera settings",
        "qPatchSize": "Size of decode window",
        "qFrequency": "Decode frequency",
        "groupDisplay": "Show ticketset / category name in ticket validation",
        "groupDisplayNone": "Show nothing",
        "groupDisplayTicketset": "Show ticketset name",
        "groupDisplayTicketsetPrice": "Show ticketset and price name",
        "groupDisplayPrice": "Show price name",
        "groupDisplayEvent": "Show both event and ticketset name",
        "olderEvents": "How long show older events after expiration",
        "olderEventsWeek": "Week",
        "olderEventsMonth": "Month",
        "olderEvents3Month": "3 months",
        "olderEvents6Month": "6 months",
        "olderEventsYear": "1 year",
        "olderEventsAll": "Show all events",
        "olderEventsAllList": "all events",
        "showTicketCount": "Show ticket count",
        "showStatistics": "Show statistics"
    },
    "statistics": {
        "title": "Statistics of ticket usage",
        "zone": "Zone",
        "today": "Today",
        "total": "Total",
        "refresh": "Refresh data"
    }
}
